import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import QuiSommesNous from '@/pages/qui-sommes-nous/page';
import NosPrestations from '@/pages/nos-prestations/page';
import Motorisation from '@/pages/motorisation-volet-charleroi/page';
import ZonesInterventions from '@/pages/zones-dinterventions/page';
import Contact from '@/pages/contact/page';
import Merci from '@/pages/merci/page';
import MentionsLegales from '@/pages/mentions-legales/page';
import PolitiqueConfidentialite from '@/pages/politique-confidentialite/page';
import CommunePage from '@/pages/reparation-volet-commune/page';
import FabricantCharleroi from '@/pages/fabricant-volet-charleroi/page';
import { toutesCommunes } from '@/data/communes';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/qui-sommes-nous/',
    element: <QuiSommesNous />,
  },
  {
    path: '/nos-prestations/',
    element: <NosPrestations />,
  },
  {
    path: '/motorisation-volet-charleroi/',
    element: <Motorisation />,
  },
  {
    path: '/zones-dinterventions/',
    element: <ZonesInterventions />,
  },
  {
    path: '/contact/',
    element: <Contact />,
  },
  {
    path: '/merci/',
    element: <Merci />,
  },
  {
    path: '/mentions-legales/',
    element: <MentionsLegales />,
  },
  {
    path: '/politique-confidentialite/',
    element: <PolitiqueConfidentialite />,
  },
  {
    path: '/fabricant-volet-charleroi/',
    element: <FabricantCharleroi />,
  },
  ...toutesCommunes
    .filter((c) => !c.estCharleroi)
    .map((c) => ({
      path: c.urlPath,
      element: <CommunePage slug={c.slug} />,
    })),
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;